export default "__VITE_PUBLIC_ASSET__bbdce440__"